<script>


export default {
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    calculateStyle: function () {
      var styles = ["TrackerDashboard"].includes(this.$route.name)
        ? { borderBottom: `3px solid #19A39C` }
        : ["Tracker"].includes(this.$route.name)
        ? {
            borderBottom: `3px solid #20356E`,
          }
        : {};
      return this.$route.meta.isEmbed
        ? styles
        : { position: "absolute", ...styles };
    },
  },
};
</script>

<template>
  <div class="dashboard-selector"
       :style="calculateStyle()">
    <div />
    <div style="height: 100%">
      <div
        v-if="['TrackerDashboard', 'Tracker'].includes($route.name)"
        class="tracker-tabs-container"
      >
        <router-link
          exact-active-class="tracker-selected"
          :to="($route.meta.isEmbed ? '/'+lang+'/public-tracker-dashboard' : '/tracker-dashboard' )"
        >
          {{ $t("label_dashboard_dashboard") }}
        </router-link>
        <router-link
          exact-active-class="tracker-selected-blue"
          :to="($route.meta.isEmbed ? '/'+lang+'/public-tracker-dashboard' : '/tracker-dashboard' )+'/tracker'"
        >
          {{ $t("label_dashboard_tracker") }}
        </router-link>
      </div>
    </div>
    <div class="dashboard-selector-dashboards">
<!--      <RouterLink v-if="!$route.meta.isEmbed" to="/dashboard"> EAW </RouterLink>
      <RouterLink v-if="!$route.meta.isEmbed" to="/tracker-dashboard">
        GESP
      </RouterLink>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
.dashboard-selector {
  display: flex;
  z-index: 999;

  width: 100%;
  height: 50px;
  justify-content: space-between;
  align-items: center;

  > div {
    flex: 1 1 0px;
  }
}

.dashboard-selector-dashboards {
  display: flex;
  gap: 30px;
  padding-right: 50px;
  justify-content: end;
}

.tracker-tabs-container {
  display: flex;
  gap: 20px;
  justify-content: center;

  > * {
    background-color: #716c6e;
    padding: 5px;
    min-width: 250px;
    text-align: center;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    font-family: Montserrat-Bold, sans-serif;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }

  align-items: end;
  height: 100%;
}

.tracker-selected {
  background-color: #19a39c !important;
}
.tracker-selected-blue {
  background-color: #20356e !important;
}
</style>
